import { capitalize } from './DataFormatterUtils';
import { nullSafeGet } from './DataAccessUtils';

export const mappingTemplateTypesForDisplay = (record) =>
	record.type.toLowerCase() === 'string' ? 'text' : record.type;

export const mappingApprovalTypesForLinks = (record) =>
	record.approvalHierarchyType === 'proposal' ? 'quoteApprovalConfig' : 'invoiceApprovalConfig';

const normalizeArray = (arr) => (arr && arr.length > 0 ? arr.slice().sort() : undefined);

export const mappingApprovalRuleComparisonData = (record) => ({
	isCapex: record.isCapex,
	isPM: record.isPM,
	woPriorityIds: normalizeArray(record.woPriorityIds),
	problemTypeIds: normalizeArray(record.problemTypeIds),
	locationIds: normalizeArray(record.locationIds),
	stockLocationIds: normalizeArray(record.stockLocationIds),
	fieldTechEmails: normalizeArray(record.fieldTechEmails),
	entityTypes: normalizeArray(record.entityTypes),
});

// Keyed on the `:type` URL segment of /approvalHierarchies/overview/rules/:type. Anything unknown
// falls back to work order, which is what the tab list redirects to.
const APPROVAL_RULES_URL_TYPES = {
	quote: 'proposal',
	invoice: 'invoice',
	purchaseRequest: 'purchaseRequest',
	requestForProposal: 'requestForProposal',
	entityRequest: 'entityRequest',
	workOrder: 'workOrder',
};

const APPROVAL_RULES_TARGET_COLLECTIONS = {
	quote: 'Quote',
	invoice: 'Invoice',
	purchaseRequest: 'PurchaseRequest',
	requestForProposal: 'RequestForProposal',
	entityRequest: 'EntityRequest',
	workOrder: 'WorkOrder',
};

const APPROVAL_RULES_BUTTON_LABELS = {
	workOrder: 'work order',
	purchaseRequest: 'purchase request',
	requestForProposal: 'request for proposal',
	entityRequest: 'suggested entity',
};

// The three tables above are plain object literals, so they inherit from Object.prototype: a
// hand-crafted URL segment like `/approvalHierarchies/overview/rules/constructor` (or `toString`)
// would resolve to an inherited function and short-circuit the `||` fallback. That value then feeds
// the redux target-collection name and getRecordsForTargetCollection throws, where the page used to
// degrade to work order. Check own-property so only real keys ever win.
const lookupOwnOrElse = (table, key, fallback) =>
	Object.prototype.hasOwnProperty.call(table, key) ? table[key] : fallback;

export const mappingApprovalRulesURLForTypes = (record) =>
	lookupOwnOrElse(
		APPROVAL_RULES_URL_TYPES,
		nullSafeGet('params.type', record),
		APPROVAL_RULES_URL_TYPES.workOrder
	);

export const mappingApprovalRulesURLForTargetCollection = (record) =>
	lookupOwnOrElse(
		APPROVAL_RULES_TARGET_COLLECTIONS,
		nullSafeGet('params.type', record),
		APPROVAL_RULES_TARGET_COLLECTIONS.workOrder
	);

export const mappingURLParamsToAddApprovalButton = (ruleType) =>
	lookupOwnOrElse(APPROVAL_RULES_BUTTON_LABELS, ruleType, ruleType);
